<template>
  <section class="cities" @click="handlerClick">
    <svg class="cities__icon">
      <use xlink:href="#svg-marker"></use>
    </svg>
    {{ userCity.cityPrintName }}
  </section>
</template>

<script lang="ts" setup>
import useModal from '@use/useModal/useModal';
import { useCitiesStore } from '@/storePinia/stores/cities';
import { storeToRefs } from 'pinia';
import GuessCity from '@components/Cities/GuessCity.vue';

const modal = useModal();
const citiesStore = useCitiesStore();

const { userCity } = storeToRefs(citiesStore);

const handlerClick = () => {
  modal.show(GuessCity, {}, { width: '340px' });
};
</script>

<style lang="scss" scoped>
.cities {
  display: flex;
  align-items: center;
  align-self: stretch;
  cursor: pointer;
  transition: 0.2s linear color;
  font-weight: 500;
  line-height: 125%;
  font-size: 16px;
  @include point-lg {
    font-size: 14px;
    margin-right: 24px;
  }
  &__icon {
    display: block;
    width: 20px;
    height: 20px;
    fill: currentColor;
    transition: 0.2s linear fill;
    margin-right: 12px;
    @include point-lg {
      margin-right: 8px;
    }
  }
  &:hover {
    color: var(--color-link-hover);
    .cities__icon {
      fill: currentColor;
    }
  }
}
</style>
